import React from 'react';
import './BoxLivescoring.css';
import { getLongNameChamp } from '../variables';
import { useNavigate } from 'react-router-dom';

function BoxLivescoring({match, championnat}) {
    const navigate = useNavigate();

    // Fonction pour avoir la bonne couleur selon le status du match 
    const getColorRecord = (status) => {
        switch (status) {
            case "bientot":
                return 'var(--yellow-color)'
            case "en_cours":
                return 'red';
            case 'termine':
                return "lightgreen";
            default:
                break;
        }
    }

    // Redirection vers le match 
    const handleClick = (e) => {
        e.preventDefault();
        // if (match.status == "en_cours") {
            navigate(`${championnat}/calendrier`, { state: {
                goTo: match.renc_id,
            }})
        // }
    }

    function Getday(tour)
    {
        if(championnat == "proad" || championnat == "probm")
        {
            if(tour == "16" || tour == "17") return "1/4";
            if(tour == "18" || tour == "19") return "1/2";
            if(tour == "20" || tour == "21") return "F";
        }
        if(championnat == "proam")
        {
            if(tour == "23" || tour == "24") return "1/2";
            if(tour == "25" || tour == "26") return "F";
        }

        return "J" + tour;
    }

    return ( 
        <div className={"box_livescoring_component " + match.status} onClick={(e)=>handleClick(e)}>
            {/* TITLE */}
            <div className={"box_livescoring_title_container " + championnat}>
                <span className="box_livescoring_title">
                   {getLongNameChamp(championnat)} - {match.heure_debut}
                </span>
                {
                    match.status == "en_cours" &&
                    <div 
                        className="record" 
                        title={match.status}
                        style={{backgroundColor: getColorRecord(match.status)}}
                    ></div>
                }
                {
                    (match.status == "bientot" || match.status == "termine") &&
                    <span
                        style={{
                            backgroundColor: getColorRecord(match.status),
                            borderRadius: 5,
                            padding: "2px 10px",
                            fontSize: 16,
                            color: "black",
                            transition: '0.2s ease-in-out all',
                        }}
                    >
                        {
                            match.status == "bientot" 
                            ? "Aujourd'hui"
                            : "Terminé"
                        }
                    </span>
                }
            </div>
            {/* CONTENT */}
            <div className="box_livescoring_content">
                <div className="box_day_container">
                    {
                        Getday(match.tour)
                    }
                </div>
                <div className="box_team">
                    <div className="box_team_line">
                        <span className="box_span_team">{match.equa}</span>
                        <span className="box_span_score">{match.score.split('-')[0].trim()}</span>
                    </div>
                    <div className="box_team_line">
                        <span className="box_span_team">{match.equb}</span>
                        <span className="box_span_score">{match.score.split('-')[1].trim()}</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BoxLivescoring;